import React from 'react';

const partners = [
  {
    
    logo: '/images/about/tsinghua.png', // 换成你实际的 logo 路径
  },
  {
    
    logo: '/images/about/beijing.png',
  },
  {
    
    logo: '/images/about/xiehe.png',
  },
  {
    
    logo: '/images/about/301.png',
  }, {
    
    logo: '/images/about/shouyi.png',
  },{
    
    logo: '/images/about/anzhen.png',
  },{
    
    logo: '/images/about/youyi.png',
  },{
    
    logo: '/images/about/beiyisanyuan.png',
  },{
    
    logo: '/images/about/zhejiang.png',
  },{
    
    logo: '/images/about/shandaqilu.png',
  },{
    
    logo: '/images/about/nanchang.png',
  },{
    
    logo: '/images/about/hebei.png',
  },
];

const PartnersSection: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          主要合作单位
        </h2>
        <p className="text-gray-600 text-center mb-10">
          与多家顶尖高校与科研机构建立长期合作，共同推动高质量科研与临床转化。
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8 items-center">
          {partners.map((partner) => (
            <div
              
              className="flex flex-col items-center justify-center space-y-3"
            >
              <div className="w-28 h-16 md:w-32 md:h-20 flex items-center justify-center bg-white rounded-xl shadow-sm">
                <img
                  src={partner.logo}
                  className="max-h-full max-w-full object-contain"
                />
              </div>
             
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
